import { api } from "@/comn";
import { Button, Group, Icon, Layout, Tab } from "@/comn/components";
import { useModal, useTab, useToast } from "@/comn/hooks";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";

type Notification = {
    bltbrdUuid: string;
    btbdmsId: string;
    btbdmsTtleNm: string;
    uprBtbdmsId?: string;
    btbdmsCn: string;
    frstRgsrDtm: string;
    frstRegstId: string;
};

export const TancisPortalMainNotification = () => {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const modal = useModal();

    const handleError = (error: any) => {
        showToast({ content: error.response?.data?.errorMessage || "error", type: "error" });
    };

    const [foundNotification, setNotification] = useState<Notification[]>([]);
    const handleHideForToday = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        localStorage.setItem("hideModalUntil", tomorrow.toISOString());
        modal.closeModal();
    };
    const isModalHiddenForToday = () => {
        const hideUntil = localStorage.getItem("hideModalUntil");
        if (!hideUntil) return false;

        const hideUntilDate = new Date(hideUntil);
        const today = new Date();

        //DOMPurify

        return hideUntilDate > today;
    };

    const findNotification = async () => {
        try {
            let base = process.env.REACT_APP_API_PTLI || "",
                path = `/api/v1/ptl/comn/comn/main/notification`;
            const response = await api.get(base + path);
            const content = response.data;
            return content;
        } catch (error) {
            console.log(error);
        }
    };

    const viewModal = (modalData: any) => {
        if (Array.isArray(modalData) && modalData.length > 0 && !isModalHiddenForToday()) {
            modal.openModal({
                content: <ModalRenderForm data={modalData} onHideForToday={handleHideForToday} />,
                title: "Notification",
                size: "xs",
                height: "500px",
                draggable: true,
                close: false,
            });
        }
    };

    useEffect(() => {
        const fetchNotificationData = async () => {
            try {
                const data = await findNotification();
                data?.notificationList.content && setNotification(data.notificationList.content);
                data?.popupNotificationList.content && viewModal(data.popupNotificationList.content);
            } catch (error) {
                handleError(error);
            }
        };

        fetchNotificationData();
    }, []);

    const firstContent = foundNotification[0];
    const restContents = foundNotification.slice(1);

    return (
        <Group>
            <Group.Header>
                <h2>Notification</h2>
            </Group.Header>
            <Group.Body>
                <Group.Section>
                    <Layout direction="col" gap={6} padding={6}>
                        {/* First content */}
                        {!!firstContent && (
                            <Layout direction="col" gap={2}>
                                <Layout align="between" valign="start" gap={8}>
                                    <button
                                        className="text-left text-primary-text underline text-xl"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate(
                                                `/ptli/ptl/btbdms/ptli1018002q/${firstContent.bltbrdUuid}/${firstContent.btbdmsId}?menuId=menu_ptli0013`,
                                            );
                                        }}
                                    >
                                        {firstContent.btbdmsTtleNm}
                                    </button>
                                    <Layout size="fit" direction="col" valign="end">
                                        <span className="text-darkgray w-24 text-right text-sm">
                                            {firstContent.frstRgsrDtm}
                                        </span>
                                        {/* <span className="font-semibold">{firstContent.frstRegstId}</span> */}
                                    </Layout>
                                </Layout>
                                <div
                                    className="line-clamp-2"
                                    dangerouslySetInnerHTML={{ __html: firstContent.btbdmsCn }}
                                />
                            </Layout>
                        )}

                        {/* Divider */}
                        {!!foundNotification.length && <div className="bg-border h-[1px]" />}

                        {/* Rest contents */}
                        {!!restContents.length && (
                            <ul className="flex flex-col gap-4">
                                {restContents.map((notification) => {
                                    const { btbdmsId, btbdmsTtleNm, frstRgsrDtm, bltbrdUuid } = notification;
                                    const key = `btbdmsId:${btbdmsId}`;
                                    return (
                                        <div key={key} className="flex items-start justify-between gap-8 relative">
                                            <div className="w-1 h-1 bg-primary-text rounded-full absolute left-0 top-2" />
                                            <button
                                                className="ml-2 text-left text-primary-text line-clamp-2 underline"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate(
                                                        `/ptli/ptl/btbdms/ptli1018002q/${bltbrdUuid}/${btbdmsId}?menuId=menu_ptli0013`,
                                                    );
                                                }}
                                            >
                                                {btbdmsTtleNm}
                                            </button>
                                            <span className="text-darkgray w-24 text-right text-sm">{frstRgsrDtm}</span>
                                        </div>
                                    );
                                })}
                            </ul>
                        )}
                    </Layout>
                </Group.Section>
            </Group.Body>
        </Group>
    );
};
export const ModalRenderForm = ({ data, onHideForToday }: { data: any; onHideForToday: () => void }) => {
    const modal = useModal();
    const { t } = useTranslation();
    const tabSchema: Array<{ label: string | number; link: string | number }> = [];
    data.map((item: any, index: number) => {
        tabSchema.push({ label: index + 1, link: index });
    });
    const tab = useTab({
        defaultSchema: {
            id: "tab",
            schema: tabSchema,
        },
    });
    return (
        <>
            <Group>
                <Group.Body>
                    <Tab {...tab.tab}>
                        {data.map((item: any, index: number) => (
                            <Tab.Panel>
                                <Group.Title title={item.btbdmsTtleNm} />
                                <Group.Section key={index}>
                                    {/* <Group.Row>
                                    <Group.Control edit={false} label={"L_BTBDMS_TTLE_NM"} value={item.btbdmsTtleNm} />
                                </Group.Row> */}
                                    <Group.Row>
                                        <div className="flex items-center p-1 col-span-12 border-l-0 border-r-0 border-t-0 border-b-0 h-[250px] overflow-auto">
                                            <div className="group/control uf-form-control w-full">
                                                <div className="relative w-full">
                                                    <div className="uf-form-control-main">
                                                        <div className="w-full relative flex items-center">
                                                            <div className="w-full">
                                                                <div
                                                                    className=" sun-editor-editable block w-[90%] min-h-100 h-[240px] "
                                                                    dangerouslySetInnerHTML={{ __html: item.btbdmsCn }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <Group.Control edit={false}
                                                //    label={"L_BTBDMS_CN"}
                                                    type="editor"
                                                    value={item.btbdmsCn}
                                                    height={300}
                                                /> */}
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control
                                            edit={false}
                                            //    label={"File"}
                                            type="file"
                                            value={item.btbdmsId}
                                        />
                                    </Group.Row>
                                </Group.Section>
                            </Tab.Panel>
                        ))}
                    </Tab>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button style={{ marginRight: "5px", marginTop: "20px" }} onClick={onHideForToday}>
                        {t("B_NOTI_HIDE")}
                    </Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        style={{ marginRight: "5px", marginTop: "20px" }}
                        role="close"
                        onClick={() => {
                            modal.closeModal();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </>
    );
};
// export const ModalRenderForm = (obj: any) => {
//     const data = obj.data;
//     return (
//         <>
//         {data.map((item: any, index: number) => (
//             <>
//             <Group>
//             <Icon icon="left"></Icon>
//             <Group>
//                 <Group.Header>
//                     <Group.Title title={item.btbdmsTtleNm}/>
//                 </Group.Header>
//                 <Group.Body>
//                     <Group.Section key={index}>
//                         {/* <Group.Row>
//                             <Group.Control edit={false} label={"L_BTBDMS_TTLE_NM"} value={item.btbdmsTtleNm} />
//                         </Group.Row> */}
//                         <Group.Row>
//                             <Group.Control edit={false}
//                                         //    label={"L_BTBDMS_CN"}
//                                             type="editor"
//                                             value={item.btbdmsCn}
//                                             height={300}
//                                         />
//                         </Group.Row>
//                         <Group.Row>
//                             <Group.Control edit={false}
//                                         //    label={"File"}
//                                             type="file"
//                                             value={item.btbdmsId}
//                                             />
//                         </Group.Row>
//                     </Group.Section>
//                 </Group.Body>
//             </Group>
//             <Icon icon="right"></Icon>
//             </Group>
//             </>
//         ))}
//         <Layout>
//             <Button style={{"marginRight": "5px"}}>하루 동안 보지 않기</Button>
//             {/* <button onClick={handleHideForToday}>하루 동안 보지 않기</button> */}
//         </Layout>
//         </>
//     )
// }
